import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useAuth } from '../context/AuthContext';
import { startSession } from '../api';
import PageBackground from '../components/PageBackground';
import './Landing.css';

export default function Landing() {
  const navigate = useNavigate();
  const { status, user, error } = useAuth();
  const [starting, setStarting] = useState(false);

  useEffect(() => {
    if (status !== 'failed') return;
    Swal.fire('Session Expired!', error || 'Unable to log you in.', 'error');
  }, [status, error]);

  const handleBeginPlay = async () => {
    setStarting(true);
    try {
      const result = await startSession({
        name: user.name,
        email: user.email,
        employeeId: user.employeeId,
        organizationId: user.organizationId,
        userId: user.userId,
        role: user.role,
      });
      if (result?.id) {
        sessionStorage.setItem('diwaliHuntStatId', String(result.id));
      }
    } catch (err) {
      console.error('startSession failed:', err);
    } finally {
      navigate('/rules');
    }
  };

  if (status === 'loading' || status === 'idle') {
    return (
      <div className="landing-page">
        <PageBackground />
        <div className="quiz-loader-container">
          <div className="quiz-loader"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="landing-page">
      <PageBackground />
      <div className="landing-content">
        <img src="/img/Hunt.gif" alt="Diwali Scavenger Hunt" className="landing-banner" />
        {status === 'succeeded' && user && (
          <button className="hunt-btn" onClick={handleBeginPlay} disabled={starting}>
            {starting ? 'Please wait...' : 'Begin Play'}
          </button>
        )}
      </div>
    </div>
  );
}
